import {
  animate,
  group,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Report } from '@app/core/models/analytics.model';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';

const SlideInOutAnimation = [
  trigger('slideInOut', [
    state(
      'in',
      style({
        'max-height': '500px',
        opacity: '1',
        visibility: 'visible',
      })
    ),
    state(
      'out',
      style({
        'max-height': '0px',
        opacity: '0',
        visibility: 'hidden',
      })
    ),
    transition('in => out', [
      group([
        animate(
          '400ms ease-in-out',
          style({
            opacity: '0',
          })
        ),
        animate(
          '600ms ease-in-out',
          style({
            'max-height': '0px',
          })
        ),
        animate(
          '700ms ease-in-out',
          style({
            visibility: 'hidden',
          })
        ),
      ]),
    ]),
    transition('out => in', [
      group([
        animate(
          '1ms ease-in-out',
          style({
            visibility: 'visible',
          })
        ),
        animate(
          '600ms ease-in-out',
          style({
            'max-height': '500px',
          })
        ),
        animate(
          '800ms ease-in-out',
          style({
            opacity: '1',
          })
        ),
      ]),
    ]),
  ]),
];

@Component({
  selector: 'app-report-item',
  templateUrl: './report-item.component.html',
  styleUrls: ['./report-item.component.scss'],
  animations: [SlideInOutAnimation],
})
export class ReportItemComponent implements OnInit {
  @ViewChild(DynamicFormComponent) DynamicFormComponent;
  @Input() details: Report;
  @Output() onReportSelect = new EventEmitter<Report>();
  @Output() onReportRun = new EventEmitter<any>();
  @Input() slide = 'out';

  constructor() {}

  ngOnInit(): void {
    //
  }

  onReportClick() {
    this.DynamicFormComponent.reset();
    this.onReportSelect.emit(this.details);
  }

  onFormSubmit(form) {
    this.onReportRun.emit({ form, report: this.details });
  }
}
